export const MEDIA_BREAKPOINTS = {
    xs: 0,
    sm: 480,
    md: 640,
    lg: 960,
    xl: 1200,
    xxl: 1400
} as const;

export const useMediaStore = defineStore('plugin:media', () =>
{
    const breakpoints = MEDIA_BREAKPOINTS;
    const width = ref(0);
    const mq = computed(() =>
    {
        return Object.entries(breakpoints)
            .filter(([, point]) => width.value >= point)
            .toSorted(([, a], [, b]) => b - a)
            .map(([key]) => key)
            .at(0) || 'xs';
    });
    const phone = computed(() => ['xs', 'sm'].includes(mq.value));
    const tablet = computed(() => ['md'].includes(mq.value));
    const mobile = computed(() => ['xs', 'sm', 'md'].includes(mq.value));
    const laptop = computed(() => ['lg'].includes(mq.value));
    const desktop = computed(() => ['xl', 'xxl'].includes(mq.value));

    function setWidth(value: number)
    {
        width.value = value;
    }

    return { width, mq, phone, tablet, mobile, laptop, desktop, setWidth };
});
